import React, { useState } from "react";
import { Box, Divider, IconButton, ListItemText, makeStyles, Menu, MenuItem, Typography } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../../contexts/authContext";

const useStyles = makeStyles((theme) => ({
    // Overriding font precedence as this component follow Platform style
    userMenu: {
        fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
        "& .MuiMenuItem-root": {
            fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
        },
        "& .MuiTypography-body1": {
            fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
        },
        "& .MuiTypography-subtitle1": {
            fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
        },
    },
    userMenuText: {
        marginLeft: theme.spacing(1.2),
    },
    menuBox: {
        marginBottom: theme.spacing(1.2),
        display: "flex",
        alignItems: "center",
    },
    userNameText: {
        fontWeight: "600 !important",
    },
    userDetailText: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: 0,
        maxWidth: "250px",
        whiteSpace: "nowrap",
        lineHeight: "1.2 !important"
    },
    menuIcon: {
        marginRight: theme.spacing(1.2),
    },
    menuIconSmall: {
        height: "21px",
        width: "21px",
        marginRight: theme.spacing(1.5),
    },
    userAvatar: {
        height: "40px",
        width: "40px",
        borderRadius: "100%",
    },
    userAvatarMenuIcon: {
        display: "flex",
        alignItems: "center",
    },
}));

const theaterComedy = `${process.env.PUBLIC_URL}/images/theater_comedy.svg`;
const helpCenter = `${process.env.PUBLIC_URL}/images/help_center.svg`;
const swapHorizon = `${process.env.PUBLIC_URL}/images/swap_horizon.svg`;
const logoutSVG = `${process.env.PUBLIC_URL}/images/logout.svg`;
const globeIcon = `${process.env.PUBLIC_URL}/images/globeIcon.svg`;

function UserMenu() {
  const classes = useStyles();
  const history = useHistory();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const open = Boolean(menuAnchorEl);
  const { rootAccounts } = useSelector(
    (state) => state.account
  );
  const {
    user,
    logout,
    isCxAdmin,
    isConsultant,
    isTutorialAdmin,
    } = useAuth();

  const goToAccountSelect = () => {
    history.push("/account-select");
  };

  const handleMenuToggle = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const goToImpersonate = () => {
    history.push("/impersonate");
  };

  const goToConsultantAccountSelect = () => {
    history.push("/consultant-account-select");
    };

    const goToGlobalArea = () => {
        history.push("/safetynest");
    }

  const goToTutorialBuilder = () => {
    history.push("/tutorial-builder");
  };

  return (
      <>
          <IconButton aria-label="User menu" aria-controls="user-menu" aria-haspopup="true" onClick={handleMenuToggle} color="inherit">
              {user?.details?.picture ? (
                  <img src={user.details.picture} className={classes.userAvatar} alt="" />
              ) : (
                  <AccountCircle className={classes.userAvatar} />
              )}
          </IconButton>
          <Menu
              id="user-menu"
              anchorEl={menuAnchorEl}
              getContentAnchorEl={null}
              keepMounted
              anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
              }}
              transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
              }}
              open={open}
              onClose={handleCloseMenu}
              onClick={handleCloseMenu}
              className={classes.userMenu}
          >
              <MenuItem>
                  <Box className={classes.userAvatarMenuIcon}>
                      {user?.details?.picture ? (
                          <img
                              src={user.details.picture}
                              className={`${classes.userAvatar} ${classes.menuIcon}`}
                              alt=""
                          />
                      ) : (
                        <AccountCircle className={`${classes.userAvatar} ${classes.menuIcon}`} />
                      )}
                  </Box>
                  <Box className={classes.userDetailText}>
                      <Typography
                          variant="body1"
                          component="div"
                          className={classes.userNameText}
                      >{`${user.details.firstName} ${user.details.lastName}`}</Typography>
                      <Typography variant="subtitle2" component="div">{`${user.details.email}`}</Typography>
                  </Box>
              </MenuItem>
              <Divider />
              {isCxAdmin && (
                  <MenuItem onClick={goToImpersonate}>
                      <img src={theaterComedy} alt="" className={classes.menuIcon} />
                      <ListItemText className={classes.userMenuText} primary="User Impersonation" />
                  </MenuItem>
              )}
              {rootAccounts.length > 1 && (
                  <MenuItem onClick={goToAccountSelect}>
                      <img src={swapHorizon} alt="" className={classes.menuIcon} />
                      <ListItemText className={classes.userMenuText} primary="Change Account" />
                  </MenuItem>
              )}

              {isConsultant && (
                  <MenuItem onClick={goToConsultantAccountSelect}>
                      <img src={swapHorizon} alt="" className={classes.menuIcon} />
                      <ListItemText className={classes.userMenuText} primary="Change Consultant Account" />
                  </MenuItem>
              )}
              {isConsultant && (
                  <MenuItem key="global-area" onClick={goToGlobalArea}>
                      <img src={globeIcon} alt="" className={classes.menuIcon} />
                      <ListItemText className={classes.userMenuText} primary="SafetyNest Global Admin" />
                  </MenuItem>
              )}
              {isTutorialAdmin && (
                  <MenuItem onClick={goToTutorialBuilder}>
                      <img src={helpCenter} alt="" className={classes.menuIconSmall} />
                      <ListItemText className={classes.userMenuText} primary="Tutorial Builder" />
                  </MenuItem>
              )}
              <Divider />
              <MenuItem onClick={logout}>
                  <img src={logoutSVG} alt="" className={classes.menuIconSmall} />
                  <ListItemText className={classes.userMenuText} primary="Logout" />
              </MenuItem>
          </Menu>
      </>
  );
}

export default UserMenu;
